import { FormFieldValue } from '..';
import { ValidationResult, ValidationRules } from '../interfaces';

export const validatePassword = async (
  value: FormFieldValue,
  props?: ValidationRules
): Promise<ValidationResult> => {
  let valid = true;
  const errors: string[] = [];

  if (typeof value === 'string') {
    if (props?.requireLowercase) {
      const lowercaseRegex = new RegExp('[a-z]+');
      const lowercaseValid = !!value.match(lowercaseRegex);
      if (!lowercaseValid) {
        valid = false;
        errors.push('Must_contain_a_lowercase_letter');
      }
    }

    if (props?.requireUppercase) {
      const uppercaseRegex = new RegExp('[A-Z]+');
      const uppercaseValid = !!value.match(uppercaseRegex);
      if (!uppercaseValid) {
        valid = false;
        errors.push('Must_contain_an_uppercase_letter');
      }
    }

    if (props?.requireDigit) {
      const digitRegex = new RegExp('[0-9]+');
      const digitValid = !!value.match(digitRegex);
      if (!digitValid) {
        valid = false;
        errors.push('Must_contain_a_digit');
      }
    }

    if (props?.requireSpecial) {
      const specialRegex = new RegExp('[!^*_.]+');
      const specialValid = !!value.match(specialRegex);
      if (!specialValid) {
        valid = false;
        errors.push('Must_contain_one_of_these_characters:_"!^*_."');
      }
    }
  }

  return { valid, errors };
};
